// Default list view dimensions, this should be greater or equal to the minimum list view dimensions
export const DEFAULT_LIST_VIEW_WIDTH: number = 350;
export const DEFAULT_LIST_VIEW_HEIGHT: number = 270;

// Min width of the window when dynamic layout is supported
export const MIN_WINDOW_WIDTH: number = 418;

// The static width of the left rail, where account switcher & module switcher live.
export const LEFT_RAIL_STATIC_WIDTH = 48;
